import React from "react"

import Signout from "components/Signout"

import { Box, FooterText } from "../components/FooterStyles"


const Footer = () => {
  return (
    <Box>
      <FooterText>   Created by Emma, Terese and Lisa | Technigo Fontend Bootcamp 2022
        <Signout />
      </FooterText>
    </Box>
  )
}

export default Footer
